import React from "react";
import Button from "../Buttons/Button";
import DropdownMenu from "../Buttons/DropdownMenu";
import Divider from "../Common/Divider";

const GlobalSearchBar = ({
  value,
  onChange,
  placeholder = "Search",
  selectedOption = "All",
  onOptionChange,
  className = "",
}) => {
  return (
    <div
      className={`flex items-center justify-center gap-3 mx-auto border border-gray-300 px-3 py-1 rounded-full shadow-md ${className} w-[500px]`}
    >
      <span className="material-symbols-outlined !text-gray-400">search</span>

      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1 border-none outline-none focus:ring-0 p-2 text-md text-black bg-transparent"
      />

      <Divider orientation="vertical" />

      <DropdownMenu
        MenuSection={
          <div className="flex flex-col p-1">
            <Button
              title="All"
              variant="text"
              color={selectedOption === "All" ? "primary" : "black"}
              className="!justify-start py-1"
              onClick={() => onOptionChange("All")}
            />
            <Button
              title="Applicant"
              variant="text"
              color={selectedOption === "Applicants" ? "primary" : "black"}
              className="!justify-start py-1"
              onClick={() => onOptionChange("Applicants")}
            />
            <Button
              title="Job Posting"
              variant="text"
              color={selectedOption === "Job Postings" ? "primary" : "black"}
              className="!justify-start py-1"
              onClick={() => onOptionChange("Job Postings")}
            />
          </div>
        }
      >
        <Button
          icon="keyboard_arrow_down"
          color="black"
          variant="text"
          iconPosition="after"
          title={selectedOption}
        />
      </DropdownMenu>
    </div>
  );
};

export default GlobalSearchBar;
